// The new-job form submits a repo as `owner/name`. The clone layer below the FE
// (butler / agent-run) breaks on a bare name, so the FE normalizes + validates
// before submit (A1EE-338). normalizeRepo canonicalizes common paste shapes but
// never invents a missing owner — isOwnerRepo is the gate the form enforces.

const HTTPS_PREFIX = 'https://github.com/';
const SSH_PREFIX = 'git@github.com:';

export function normalizeRepo(raw: string): string {
  let v = raw.trim();
  if (v.startsWith(HTTPS_PREFIX)) v = v.slice(HTTPS_PREFIX.length);
  else if (v.startsWith(SSH_PREFIX)) v = v.slice(SSH_PREFIX.length);
  if (v.endsWith('.git')) v = v.slice(0, -'.git'.length);
  if (v.endsWith('/')) v = v.slice(0, -1);
  return v;
}

const OWNER_REPO = /^[^/\s]+\/[^/\s]+$/;

export function isOwnerRepo(value: string): boolean {
  return OWNER_REPO.test(value);
}
